const DiaryDetails = {
  'id': 'DiaryDetails',
  'layout': {
    'rows': 1,
    'columns': 1
  },
  'fields': [
    {
      'id': '1',
      'type': 'PAPER_CONTAINER',
      'props': {
        'name': 'DiaryDetails',
        'fullWidth': true
      },
      'position': {
        'row': 1,
        'col': 1,
        'colspan': 2
      },
      'children': [
        {
          id: 1,
          type: 'DIARY_DETAILS',
          props: {
            label: 'DiaryDetails',
            name: 'DiaryDetails',
            createApi: 'SalesOrderEnquiry/SalesOrder/<SalesOrder>/CreateDiary',
            searchByIdApi: '/SalesOrderEnquiry/SalesOrder/<SalesOrder>/Diary/<DiaryId>',
            updateApi: '/SalesOrderEnquiry/SalesOrder/<SalesOrder>/Diary/<DiaryId>',
            deleteApi: '/SalesOrderEnquiry/SalesOrder/<SalesOrder>/Diary/<DiaryId>',
          }
        }
      ]
    }
  ]
}
export default DiaryDetails
